import classNames from 'classnames/bind';
import Button from 'mcs-toolkit/components/Button';
import Input from 'mcs-toolkit/components/Input';
import React from 'react';
import { copyStringToClipboard } from 'system/libs/copyStringToClipboard';

import IconEye from 'reactApp/components/icons/eye';
import IconEyeOff from 'reactApp/components/icons/eyeOff';
import IconCopy from 'reactComponents/icons/IconCopy';

import styles from './InputPassword.css';

const css = classNames.bind(styles);

export class InputPassword extends React.Component {
    state = {
        shouldShowPassword: this.props.shouldShowPassword,
    };

    _onEyeClick = () => {
        this.setState({
            shouldShowPassword: !this.state.shouldShowPassword,
        });
        const { onVisibilityChange = () => {} } = this.props;
        onVisibilityChange({
            isVisible: !this.state.shouldShowPassword,
        });
    };

    _renderIcons = () => {
        const { showCopyIcon } = this.props;
        const EyeIcon = this.state.shouldShowPassword ? IconEyeOff : IconEye;
        return (
            <div className={css('iconContainer')}>
                <EyeIcon
                    className={css('icon')}
                    onClick={this._onEyeClick}
                    width={20}
                    height={20}
                />
                {showCopyIcon && (
                    <IconCopy
                        className={css('icon')}
                        onClick={this.copyValue}
                        width={20}
                        height={20}
                    />
                )}
            </div>
        );
    };

    copyValue = () => {
        copyStringToClipboard(
            this.props.value,
            'Значение скопировано в буффер обмена',
        );
    };

    render() {
        const {
            className,
            generatePassword,
            disabled,
            shouldShowPassword,
            onVisibilityChange,
            showGenerateButton,
            showCopyButton,
            showCopyIcon,
            fullWidth,
            ...otherProps
        } = this.props;

        return (
            <div className={css('root', className, { fullWidth })}>
                <Input
                    {...otherProps}
                    type={this.state.shouldShowPassword ? 'text' : 'password'}
                    icon={this._renderIcons()}
                    disabled={disabled}
                    className={css('input')}
                />

                {showGenerateButton && (
                    <div>
                        <Button
                            type="button"
                            onClick={generatePassword}
                            className={css('generateButton')}
                            disabled={disabled}
                        >
                            Сгенерировать
                        </Button>
                    </div>
                )}

                {showCopyButton && (
                    <Button
                        type="button"
                        onClick={this.copyValue}
                        className={css('copyButton')}
                        disabled={disabled}
                    >
                        <IconCopy />
                    </Button>
                )}
            </div>
        );
    }
}
